import { render, staticRenderFns } from "./ServiceMessage.vue?vue&type=template&id=7495da2e"
import script from "./ServiceMessage.vue?vue&type=script&lang=js"
export * from "./ServiceMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports